import axes from '../mixins/axes'

export default {
  name: 'LaYAxis',

  axis: 'y',

  space: [10, 0, 0, 40],

  mixins: [axes]
}
